import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import {
  SetupProjectSummary,
  SetupProjectSummaryAutority,
  SetupProjectSummaryCondition,
} from 'models/setup/home/SetupProjectSummary';
import { SetupProjectGraph, SetupProjectGraphCondition } from 'models/setup/home/SetupProjectGraph';
import { Code } from 'models/common/CommonCode';

/**
 * 프로젝트별 요약 > 샘플일정
 */
export const findSetupPrjSummSampleSchedule = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/sample-schedule`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummary[];
};

/**
 * 프로젝트별 요약 > Dashboard
 */
export const findSetupPrjSummDashboard = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/dashboard`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummary[];
};

/**
 * 프로젝트별 요약 > 실적 List
 */
export const findSetupPrjSummTrackRecord = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/track-record`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummary[];
};

/**
 * 프로젝트별 요약 > 지연 및 이슈
 */
export const findSetupPrjSummDelayIssue = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/delay-issue`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummary[];
};

/**
 * 프로젝트별 요약 > 지연 및 이슈 > 즐겨찿기 업데이트
 */
export const updateSetupPrjSummDelayIssue = async (condition: SetupProjectSummary) => {
  const request: CommonRequest = {
    method: Method.PUT,
    url: `/v1/setup/project-summary/delay-issue`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: condition,
  };

  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 프로젝트별 요약 > FOB 협력업체 진행률
 */
export const findSetupPrjSummExcpList = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/fob-excp-rate`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummary[];
};

/**
 * 설비별 현장 이미지 조회
 */
export const findSetupOnSiteImage = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/on-site-img`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummary[];
};

/**
 * 프로젝트 요약 페이지 권한 조회
 */
export const findSetupPrjSummAuth = async (condition: SetupProjectSummaryCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/auth`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectSummaryAutority[];
};

/**
 * 프로젝트 요약 > 주간 진행률 그래프
 */
export const findSetupPrjSummGraph = async (condition: SetupProjectGraphCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/graph`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupProjectGraph[];
};

/**
 * 프로젝트 요약 > 주간 진행률 그래프 x-axis
 */
export const findSetupPrjSummGraphAxis = async (condition: SetupProjectGraphCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/project-summary/graph-axis`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as Code[];
};
